export const BACKEND_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.tnpnsut.in"
    : "http://localhost:1337";

export const inputFields = [
  // {
  //   label: "Name",
  //   name: "name",
  //   type: "text",
  // },
  // {
  //   label: "Gender",
  //   name: "gender",
  //   type: "select",
  //   options: [
  //     { value: "", name: "Select Gender" },
  //     { value: "Male", name: "Male" },
  //     { value: "Female", name: "Female" },
  //     { value: "Other", name: "Other" },
  //   ],
  // },
  // {
  //   label: "Date of Birth",
  //   name: "dob",
  //   type: "date",
  // },
  // {
  //   label: "Blood Group",
  //   name: "blood_group",
  //   type: "text",
  // },
  // {
  //   label: "Roll Number",
  //   name: "username",
  //   type: "text",
  // },

  {
    label: "Category",
    name: "category",
    type: "select",
    options: [
      { value: "", name: "Select Category" },
      { value: "GENERAL", name: "GENERAL" },
      { value: "EWS", name: "EWS" },
      { value: "OBC", name: "OBC" },
      { value: "SC", name: "SC" },
      { value: "ST", name: "ST" },
      { value: "PWD", name: "PWD" },
    ],
  },
  {
    label: "Batch",
    name: "batch",
    type: "select",
    options: [
      { value: "", name: "Select Batch" },
      { value: "2025", name: "2025" },
      { value: "2026", name: "2026" },
      { value: "2027", name: "2027" },
      { value: "2028", name: "2028" },
      { value: "2029", name: "2029" },
      { value: "2030", name: "2030" },
    ],
  },
  {
    label: "Degree",
    name: "degree",
    type: "select",
    options: [
      { value: "", name: "Select Degree" },
      { value: "BTech", name: "BTech" },
      { value: "MTech", name: "MTech" },
      { value: "MBA", name: "MBA" },
      { value: "BBA", name: "BBA" },
      { value: "MSc", name: "MSc" },
      { value: "BDesign", name: "BDesign" },
      { value: "MA", name: "MA" },
    ],
  },
  {
    label: "Branch",
    name: "branch",
    type: "select",
  },
  // {
  //   label: "Personal Email",
  //   name: "personal_email",
  //   type: "email",
  // },
  // {
  //   label: "Contact Number",
  //   name: "contact_no",
  //   type: "number",
  //   minLength: 10,
  //   maxLength: 10,
  // },
  // {
  //   label: "Permanent Contact Number",
  //   name: "perm_contact_no",
  //   type: "number",
  //   minLength: 10,
  //   maxLength: 10,
  // },

  // {
  //   label: "Current Address",
  //   name: "current_address",
  //   type: "text",
  // },
  // {
  //   label: "Permanent Address",
  //   name: "perm_address",
  //   type: "text",
  // },
  {
    label: "Class 10 Percentage",
    name: "class_10",
    type: "number",
    placeholder: "ex: 90",
  },
  {
    label: "Class 12 Percentage",
    name: "class_12",
    type: "number",
    placeholder: "ex: 90",
  },
  // {
  //   label: "Aadhaar Number",
  //   name: "addhar",
  //   type: "text",
  // },
  // {
  //   label: "Pan Card Number",
  //   name: "pan",
  //   type: "text",
  // },
  {
    label: "IMS Password",
    name: "password",
    type: "password",
    placeholder: "password",
  },
  {
    label: "Captcha",
    name: "captcha",
    type: "captcha",
    placeholder: "Fill the captcha",
  },
];

export const newRegisterFormData = {
  // gender: "",
  username: "",
  password: "",
  captcha: "",
  category: "",
  degree: "",
  batch: "",
  branch: "",
  // contact_no: "",
  // perm_address: "",
  class_10: "",
  class_12: "",
  // name: "",
  // current_address: "",
  // perm_contact_no: "",
  // dob: "",
  // addhar: "",
  // blood_group: "",
  // pan: "",
  // personal_email: "",
};

const toBranchOptions = (branches) => [
  { value: "", name: "Select Branch" },
  ...branches.map((branch) => ({ value: branch, name: branch })),
];

export const branchesByDegree = {
  BTech: toBranchOptions([
    "CSE",
    "CSAI",
    "CSDS",
    "CSDA",
    "MAC",
    "CIOT",
    "IT",
    "ITNS",
    "IIOT",
    "ECE",
    "EIOT",
    "ECAM",
    "EVDT",
    "ICE",
    "EE",
    "ME",
    "MPAE",
    "MEEV",
    "BT",
    "CIVIL",
    "AI",
    "EVLSI",
    "VLSI",
    "GI",
  ]),
  MTech: toBranchOptions([
    "PEVLSI",
    "PVLSI",
    "PIT",
    "PCS",
    "PCSAI",
    "PAI",
    "PEE",
    "PME",
    "PSE",
    "PBI",
    "PIS",
    "PAD",
    "PCY",
    "PQT",
  ]),
  BDesign: toBranchOptions(["BDesign"]),
  BBA: toBranchOptions(["BBA"]),
  MBA: toBranchOptions(["MBA"]),
  MSc: toBranchOptions([
    "Physics",
    "Mathematics",
    "Chemistry",
    "Bioinformatics",
    "Environment",
  ]),
  MA: toBranchOptions([
    "English",
    "Psychology",
    "Mathematics",
    "Physics",
    "Chemistry",
  ]),
};

export function getBranchOptionsForDegree(degree) {
  if (!degree) {
    return [{ value: "", name: "Select Degree First" }];
  }
  return branchesByDegree[degree] || [{ value: "", name: "Select Branch" }];
}

export function getRegisterSelectOptions(field, degree) {
  if (field.name === "branch") {
    return getBranchOptionsForDegree(degree);
  }
  return field.options;
}

export function updateRegisterFormField(formData, name, value) {
  if (name === "degree") {
    return { ...formData, degree: value, branch: "" };
  }
  return { ...formData, [name]: value };
}

const degreesToSem = {
  "BTech": 8,
  "MTech": 4,
  "MBA": 4,
  "BBA": 6,
  "MSc": 4,
  "BDesign": 8,
  "MA": 4,
}


const EventType = {
  Internship: "Internship",
  Internship_PPO: "Internship+PPO",
  Internship_FTE: "Internship+FTE",
  FTE: "FTE",
  Placement: "Placement",
} 

const EventTypeList = Object.values(EventType);

export { degreesToSem, EventType, EventTypeList };

